export const SectionHeading = ({ overline, title, accent, children, align = "left" }) => (
  <div className={`mb-10 md:mb-14 ${align === "center" ? "text-center" : ""}`} data-testid="section-heading">
    {overline && <p className="overline-ae mb-3">{overline}</p>}
    <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-deepgreen">
      {title} {accent && <span className="font-accent text-sage text-4xl sm:text-5xl lg:text-6xl">{accent}</span>}
    </h2>
    {children && <p className={`mt-4 max-w-2xl text-base text-muted-foreground leading-relaxed ${align === "center" ? "mx-auto" : ""}`}>{children}</p>}
  </div>
);
